import React from 'react'

import { formatName } from '@paintscout/util/builder'
import type { TaskActivityDetails } from '@paintscout/api'
import Highlight from '../../Highlight'
import type { ActivityTypeComponentProps } from '../Activity'
import ActivityFooter from '../ActivityFooter'
import ActivityTitle from '../ActivityTitle'
import QuoteActivitySubtitle from '../QuoteActivitySubtitle'

export default function TaskActivity(props: ActivityTypeComponentProps) {
  const { activity, showDocTypeDetails } = props
  const activityType = activity.details?.activityType
  const action = (activityType || '').replace('task-', '')

  const ownerToDisplay = activityType === 'task-assigned' ? activity.details.quoteOwner : activity.details.owner

  const isTemplateAdded = activityType === 'task-created' && !!(activity.details as TaskActivityDetails)?.templateId

  return (
    <>
      <ActivityTitle>
        {isTemplateAdded ? (
          <>
            <Highlight>Checklist</Highlight> was <Highlight>added</Highlight> by
          </>
        ) : (
          <>
            <Highlight>Task</Highlight> was <Highlight>{action}</Highlight>{' '}
            {activityType === 'task-assigned' ? 'to' : 'by'}
          </>
        )}

        {'  '}
        <Highlight>{formatName(ownerToDisplay)}</Highlight>
      </ActivityTitle>
      <QuoteActivitySubtitle activity={activity} showDocTypeDetails={showDocTypeDetails} />
      <ActivityFooter timestamp={activity.details.timestamp} />
    </>
  )
}
